/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Endzeit1Inputs */

const de__field_endzeit1 = /** @type {(inputs: _Field_Endzeit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endzeit`)
};

/**

* @param {_Field_Endzeit1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_endzeit1 = /** @type {((inputs?: _Field_Endzeit1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Endzeit1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_endzeit1(inputs)
});
export { _field_endzeit1 as "_field_endZeit" }